import { z } from 'zod/v4';
import {
  AmforiSyncStatusSchema,
  AmforiSyncTriggerSourceSchema,
} from './sync-status.js';

/**
 * One past sync run as surfaced by `GET /integrations/amfori/history` and
 * rendered in the brand-side "Report activity" table.
 *
 * `errorsCount` / `warningsCount` are NOT the `amfori_sync_history` counter
 * columns — they are live counts of `ERROR` / `WARN` rows in
 * `amfori_sync_step_logs` for the run (so they are accurate for in-flight runs
 * too). `completedAt` / `durationMs` are `null` while a run is `RUNNING`.
 * `warningsCount` leaves out the warnings the brand archived, which
 * `archivedWarningsCount` counts (DELTA-2763).
 */
export const AmforiSyncHistoryResourceSchema = z
  .object({
    syncHistoryId: z.string(),
    trigger: AmforiSyncTriggerSourceSchema,
    status: AmforiSyncStatusSchema,
    startedAt: z.string(),
    completedAt: z.string().nullable(),
    durationMs: z.number().nullable(),
    errorsCount: z.number(),
    warningsCount: z.number(),
    archivedWarningsCount: z.number(),
    suppliersMatched: z.number(),
    suppliersUnmatched: z.number(),
    auditsCreated: z.number(),
    dataPointsWritten: z.number(),
    findingsCreated: z.number(),
  })
  .strict();

export type AmforiSyncHistoryResource = z.infer<
  typeof AmforiSyncHistoryResourceSchema
>;
